# Коллекция для формы редактирования (порт референсного EditCollectionQuery)
query Collection($id: ID!) {
  content(id: $id) {
    id
    type
    title
    description
    publishAt
    accessStartAt
    hideInGeneralLists
    onlyUsers
    url
    path
    preview {
      id
      url(format: HIGH)
    }
    verticalPreview {
      id
      url
    }
    tags {
      id
      title
    }
    countryAccess {
      id
      title
    }
    collectionIds
    productIds
    collectionTypeId
    collectionType {
      id
      title
    }
    collectionContentSort
    hideChildrenContentFromLists
    createdAt
    updatedAt
  }
}
